import { render, staticRenderFns } from "./sosInfoDetail.vue?vue&type=template&id=1aa0fcb2&scoped=true&"
import script from "./sosInfoDetail.vue?vue&type=script&lang=js&"
export * from "./sosInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./sosInfoDetail.vue?vue&type=style&index=0&id=1aa0fcb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0fcb2",
  null
  
)

export default component.exports